import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection
} from "angularfire2/firestore";
import "rxjs/add/operator/take";
import { Block } from "../../models/block.interface";
import { Environment } from "../../environment/environment";
import { ToastProvider } from "../toast/toast";

@Injectable()
export class FirestoreProvider {
  blockAfsRef: AngularFirestoreDocument<any>;
  constructor(private afs: AngularFirestore,
  public toast: ToastProvider) {}

  // Get an object from Firestore by its path. For eg: firestore.get('users/' + userId) to get a user object.
  public get(path: string): Promise<AngularFirestoreDocument<{}>> {
    return new Promise(resolve => {
      resolve(this.afs.doc(path));
    });
  }

  // Check if the object exists on Firestore. Returns a boolean promise with true/false.
  public exists(path: string): Promise<boolean> {
    return new Promise(resolve => {
      this.afs.doc(path).valueChanges().take(1).subscribe(res => {
        if (res) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }
  
  public addBlock(block, blocks) {
    let count = blocks.length - 1;
    this.blockAfsRef = this.afs.doc(`testnet4/${count}`);
    this.blockAfsRef.set(block).catch(err => {
      this.toast.quickShow(err);
    });
  }

  public addGenesis(block, blocks) {
    if (blocks.length == 0) {
      this.blockAfsRef = this.afs.doc(`testnet4/0`);
      this.blockAfsRef
        .set(Environment.genesisBlock)
        .then(() => {
          this.addBlock(block, blocks);
        })
        .catch(err => {
          this.toast.quickShow(err);
        });
    }
  }

  public addVerification(companyDetails, user){
    let companyRef = this.afs.collection(`verificationList`);
    companyRef.add(companyDetails).catch(err=>{
      this.toast.quickShow(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/firestore/firestore.ts